import yup from 'utils/yup';

interface IBankExpenseValues {
  id?: string;
  name?: string;
  accountType?: string;
}

export const initialBankExpenseData = (
  intialBankValues: IBankExpenseValues,
  initialExpenseValues: IBankExpenseValues
) => {
  return {
    bank_account: intialBankValues ?? ({ id: '', name: '', accountType: '' } as any),
    expense_account: initialExpenseValues ?? ({ id: '', name: '', accountType: '' } as any),
  };
};

export const bankExpenseDataValidationSchema = yup.object().shape({
  bank_account: yup
    .object()
    .shape({
      id: yup.string().required(),
      name: yup.string(),
      accountType: yup.string(),
    })
    .required('This is required'),
  expense_account: yup
    .object()
    .shape({
      id: yup.string().required(),
      name: yup.string(),
      accountType: yup.string(),
    })
    .required('This is required'),
});
